import React from "react";
import service1 from "../../assets/img/bg/3.png";
import service2 from "../../assets/img/icon/18.svg";
import service3 from "../../assets/img/icon/16.svg";
import service4 from "../../assets/img/icon/17.svg";
import service5 from "../../assets/img/icon/20.svg";
import { IoArrowForwardSharp } from "react-icons/io5";

const services = [
  {
    id: 1,
    title: "Web Development",
    description:
      "We offer expert web design and development, creating responsive, visually appealing websites that enhance user experience and drive business growth",
    image: service2,
    backgroundImage:
      "url('https://externlabs.com/blogs/wp-content/uploads/2022/04/b1.jpg')",
  },
  {
    id: 2,
    title: "Digital Marketing",
    description:
      "We deliver tailored digital marketing services, including SEO, content, social media, and PPC, to enhance your online presence",
    image: service3,
    backgroundImage:
      "url('https://externlabs.com/blogs/wp-content/uploads/2022/04/b2.jpg')",
  },
  {
    id: 3,
    title: "IT Training",
    description:
      "We offer hands-on web development training, covering HTML, CSS, JavaScript, and advanced frameworks, preparing you for real-world challenges",
    image: service4,
    backgroundImage:
      "url('https://externlabs.com/blogs/wp-content/uploads/2022/04/b3.jpg')",
  },
  {
    id: 4,
    title: "Mobile App",
    description:
      "We deliver custom mobile app solutions, from concept to deployment, ensuring user-friendly, high-performance apps that drive business growth",
    image: service5,
    backgroundImage:
      "url('https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTMUoepCOenPui7HaXXhc4Bm5ryDzchHym-8w&s')",
  },
];

function Service() {
  return (
    <>
      <div
        className="service-area bg-cover pd-top-120 pd-bottom-90"
        style={{ backgroundImage: `url(${service1})` }}
      >
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-6 col-lg-8">
              <div className="section-title text-center">
                <h6 className="sub-title">WHAT WE OFFER</h6>
                <h2 className="title">
                  It <span>Service</span> Refers To The Provision Of Support
                </h2>
              </div>
            </div>
          </div>
          <div className="row">
            {services.map((service) => (
              <div key={service.id} className="col-xl-3 col-md-6">
                <div className="single-work-process-inner mobileView">
                  <div className="thumb mb-4">
                    <img src={service.image} alt="img" />
                  </div>
                  <div className="details">
                    <h5 className="mb-3">{service.title}</h5>
                    <p className="content mb-3">{service.description}</p>
                    {/* <a className="read-more-text">
                      Read More <IoArrowForwardSharp />
                    </a> */}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default Service;
